<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
padding: 0;
margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue